module.exports = __webpack_public_path__ + "img/icons8-skype.995fee33.svg";